import { AnyAction } from 'redux';
import { getDetailsByRefrenceType } from '../types/api-types';
import { LOGOUT_SUCCESS } from '../types/auth';
import {
  GET_DEFAULT_ADDRESS_SUCCESS,
  GET_DETAILS_BY_REFRENCE_SUCCESS,
  GET_OTP_SUCCESS,
  UPDATE_KYC_ON_PROCEED_SUCCESS,
} from '../types/onBoarding';

const initState: Partial<getDetailsByRefrenceType> = {
  applicationId: '',
  referenceId: '',
  applicant_type: '',
  esignReferenceId: '',
  id: '',
};

function refrenceIdReducer(
  state = initState,
  action: AnyAction
): Partial<getDetailsByRefrenceType> {
  switch (action.type) {
    case GET_DETAILS_BY_REFRENCE_SUCCESS: {
      return {
        ...state,
        ...action.body,
      };
    }
    case UPDATE_KYC_ON_PROCEED_SUCCESS:
    case GET_DEFAULT_ADDRESS_SUCCESS: {
      return {
        ...state,
        ...action.body.applicant,
      };
    }
    case LOGOUT_SUCCESS:
    case GET_OTP_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default refrenceIdReducer;
